import { css } from "styled-system/css";
import { PERIOD_OPTIONS, usePeriod } from "~/lib/period";

export function PeriodPicker() {
  const { period, setPeriod, window } = usePeriod();

  return (
    <div className={styles.wrap}>
      <span className={styles.caption}>
        {window.label} <span className={styles.vs}>{window.vsLabel}</span>
      </span>
      <div role="radiogroup" aria-label="Reporting period" className={styles.group}>
        {PERIOD_OPTIONS.map((opt) => (
          <button
            key={opt.value}
            type="button"
            role="radio"
            aria-checked={period === opt.value}
            title={opt.label}
            onClick={() => setPeriod(opt.value)}
            className={styles.option}
            data-active={period === opt.value || undefined}
          >
            {opt.short}
          </button>
        ))}
      </div>
    </div>
  );
}

const styles = {
  wrap: css({ display: "flex", alignItems: "center", gap: 3 }),
  caption: css({
    fontSize: "sm",
    color: "fg.default",
    fontWeight: "medium",
    display: { base: "none", md: "inline" },
  }),
  vs: css({ color: "fg.muted", fontWeight: "normal" }),
  group: css({
    display: "inline-flex",
    p: "2px",
    bg: "bg.subtle",
    border: "1px solid",
    borderColor: "border.default",
    borderRadius: "md",
  }),
  option: css({
    px: 3,
    py: 1,
    fontSize: "sm",
    fontWeight: "medium",
    color: "fg.muted",
    borderRadius: "sm",
    cursor: "pointer",
    transition: "background 300ms cubic-bezier(0.2, 0, 0, 1)",
    _hover: { color: "fg.default" },
    "&[data-active]": { bg: "bg.default", color: "fg.default" },
  }),
};
